import
{
    ZoneItem
} from "@ews/react-data";

import
{
    FC
} from "react";

import s from '../SystemDocumentation.module.scss';
import { useL10n } from "@ews/react-localization-context";

const TableZones: FC<{ data: ZoneItem[]; }> = ({
    data
}) =>
{

    const { translate: t } = useL10n();
    if (!data) return <>{t("[REACT_NO_DATA]")}</>;
    return <table id='system-documentation-zones' data-name='Bediengruppenverzeichnis' className={s.table}>
        < thead >
            <tr>
                <td style={{ width: "150px" }}></td>
                <td style={{ width: "80px" }}></td>
                <td style={{ width: "80px" }}></td>
                <td style={{ width: "290px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "17px" }}></td>
                <td style={{ width: "49px" }}></td>
            </tr>
        </thead >
        <tbody>
            <tr>
                <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={4}>{t("[REACT_FIRE_ALARM_SYSTEM]")}</td>
                <td className={`${s.b} ${s.title}`} colSpan={14}>{t("[REACT_TRVB_123_S]")}</td>
            </tr>
            <tr>
                <td className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`} rowSpan={2} colSpan={4}>Bedienungsgruppenverzeichnis (für Brandmeldegruppen)</td>
                <td className={`${s.bR} ${s.title}`} colSpan={14}>{t("[REACT_ANHANG_1]")}</td>
            </tr>
            <tr>
                <td className={`${s.bR} ${s.title}`} colSpan={14}>{t("[REACT_BGVZ]")}</td>
            </tr>
            <tr>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>Übertragungsgruppe </td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_BEDIENGRUPPE]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_ANZEIGEGRUPPE]")}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}>{t("[REACT_RANGE]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("HEAT_DETECTOR")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[SID_LEL_TYPE_OPT]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_MULTIKRITERIENMELDER]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[SID_GRP_KIND_MCP]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_FLAME_DETECTOR]")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("TD_RAUCHANSAUGSYSTEM")}</td>
                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[REACT_VENTILATION_DUCT_DETECTOR]")}</td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                <td className={`${s.b} ${s.aT} ${s.tL}`}></td>

                <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>{t("[SID_DLG_TXT_PLAN_NR]")}</td>
            </tr>
            {data.map((item, idx) => (
                'to' in item ? (<>
                    <tr className={s.greyRow}>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}> {item.from}</td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                    </tr>
                    <tr className={s.greyRow}>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}>
                            {' bis '}
                        </td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                    </tr>
                    <tr className={s.greyRow}>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}>
                            {item.to}
                        </td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                    </tr>
                </>)
                    : (

                        <tr>
                            <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.transmissionGroup}</td>
                            <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.groupNumber}</td>
                            <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.elementNumber}</td>
                            <td colSpan={1} className={`${s.b} ${s.aT} ${s.tL}`}>{item.location}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>
                                {item.detectorType === "ThermDetect D"
                                    ? "D"
                                    : item.detectorType === "ThermDetect M"
                                        ? "M"
                                        : ""}
                            </td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.detectorType && item.detectorType === "OpticalDetect" ? '1' : ''}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.detectorType && item.detectorType === "MultiDetect" ? '1' : ''}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.detectorType && item.detectorType === "MCP" ? '1' : ''}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.detectorType && item.detectorType === "IonisDetect" ? '1' : ''}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}>{item.detectorType && item.detectorType === "SpecDetect" ? '1' : ''}</td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                            <td className={`${s.b} ${s.aT} ${s.tL}`}></td>
                        </tr>)
            ))}
        </tbody>
    </table >;
};

export default TableZones;
